import { axios } from '@/utils/axios'
// import _ from 'lodash'
// import moment from 'moment'
// import Storage from '@/assets/js/storage'

// 选择优惠券
export async function addCoupon (params) {
  try {
    return await axios.post('/api/order/coupon/add', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 取消选择优惠券
export async function removeCoupon (params) {
  try {
    return await axios.post('/api/order/coupon/delete', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 我的优惠券
export async function queryMyCoupon (params) {
  try {
    return await axios.post('/api/venus/queryMyCouponList', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 激活优惠券
export async function activeMyCoupon (params) {
  try {
    const { loginName } = window.__MICRO_ROOT__.user?.get() || {}
    const data = {
      channel: 'NN',
      activeAccount: loginName
    }

    return await axios.post('/api/venus/activeConpon', { ...data, ...params })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询优惠券 - 机票、随票辅营
export async function queryCoupon (params) {
  try {
    return await axios.post('/api/venus/queryPlaceCoupons', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询优惠券 - 单独辅营
export async function queryAloneCoupon (params) {
  try {
    return await axios.post('/api/venus/queryPlaceMsCoupons', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 我的优惠券
export async function myCoupon (params) {
  try {
    const { loginName } = window.__MICRO_ROOT__.user?.get() || {}
    const data = {
      channel: 'NN',
      loginId: loginName
    }

    return await axios.post('/api/venus/queryMyCouponList', { ...data, ...params })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 我的卡券
export async function queryMyCouponList (params) {
  try {
    return await axios.post('/api/hnacoupon/queryMyCouponList', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 卡券详情
export async function queryCouponDetail (code) {
  try {
    return await axios.post(`/api/hnacoupon/couponDetail/${code}`)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查看可用卡券
export async function queryCardCoupon (params) {
  try {
    return await axios.post('/api/cardCoupon/queryCardCoupon', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 使用卡券
export async function addCardCoupon (params) {
  try {
    return await axios.post('/api/cardCoupon/addCardCoupon', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 激活卡券
export async function bindingCardCoupon (params) {
  try {
    return await axios.post('/api/hnacoupon/binding', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
